export const Bio = {
  name: "Myo Hein Htet 😎",
  roles: [
    "Power Platform Developer",
    "Data Enthusiast",
  ],
  description:
    "I am just an ordinary person, but I believe that even ordinary people can achieve extraordinary things when they believe in themselves. That belief fuels my passion to never give up, no matter what. As long as the sun rises, I'll keep pursuing what I love and following my dreams. Giving up isn't an option in my life because I know I have the power to persevere until the end of the day🔥",
  github: "https://github.com/MyoHein1999",
  resume:
    "https://drive.google.com/file/d/1FJmQhJcHQOQzgUJ4oT4dizDYSzJF8QlK/view",
  linkedin: "https://www.linkedin.com/in/myo-hein-htet-58a7091b9/",
  twitter: "#",
  insta: "#",
  facebook: "#",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      // {
      //   name: "Next Js",
      //   image:
      //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      // },
      // {
      //   name: "Angular Js",
      //   image:
      //     "https://camo.githubusercontent.com/8886130b3d8aba95dbdd7c4f9a41029606424cc06d1873c1ced87dd55a222fef/68747470733a2f2f616e67756c61722e696f2f6173736574732f696d616765732f6c6f676f732f616e67756c61722f616e67756c61722e737667",
      // },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Microsoft",
    skills: [
      {
        name: "Power Apps",
        image: "https://i0.wp.com/mattruma.com/wp-content/uploads/2021/10/PowerApps.png?fit=512%2C512&ssl=1",
      },
      {
        name: "Power BI",
        image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/New_Power_BI_Logo.svg/2048px-New_Power_BI_Logo.svg.png",
      },
      {
        name: "Power Automate",
        image: "https://images.squarespace-cdn.com/content/v1/62460a56418af8236d4f3fee/e00b4d15-e244-4d5c-976e-01aa54763133/powerautomate-small%406x.png",
      },
      {
        name: "Power Pages",
        image:
          "https://www.northware.mx/wp-content/uploads/2022/09/northware-microsoft-power-pages-logo.png",
      },
      {
        name: "Power Virtual Agent",
        image:
          "https://static-00.iconduck.com/assets.00/power-virtual-agents-colored-icon-256x244-epntum9r.png",
      },
      {
        name: "D365 Marketing",
        image:
          "https://staging.creakom.de/wp-content/uploads/2022/08/D365-Marketing-1.png",
      },
      {
        name: "D365 CRM",
        image:
          "https://www.microsoft.com/content/dam/microsoft/final/en-us/microsoft-brand/logo/Logo_CustomerService_scalable.png",
      },
      {
        name: "MySQL",
        image:
          "https://1000logos.net/wp-content/uploads/2020/08/MySQL-Logo.png",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      // {
      //   name: "Keras",
      //   image:
      //     "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      // },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://i.namu.wiki/i/zKS7LsOc2A4ZZR64XnAm8S88HbszoXQPH_T7CY3KFwfwJtemXQwc4Nu3tx5GavmyG-wmgcKs_PfqYbY8xg3iow.webp",
      },
      // {
      //   name: "Sk Learn Kit",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      // },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      // {
      //   name: "Figma",
      //   image:
      //     "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      // },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://i0.wp.com/www.techarp.com/wp-content/uploads/2019/03/ASEAN-Data-Science-Explorers-2019.jpg?fit=624%2C406&ssl=1",
    role: "Master Trainer",
    company: "ASEAN DATA SCIENCE EXPLORER PROGRAM",
    date: "March 2024 - June 2024",
    desc: "As a low-code/no-code developer, I'm always seeking opportunities to empower young people with innovative tools. Partnering with Thate Pan Hub and the ASEAN Foundation, I've had the chance as a trainer to lead workshops introducing SAP Analytics Cloud and SAP Build apps to over 90 enthusiastic students between 15 and 30. For me, it wasn't just about transferring knowledge – it was about equipping them with the tools and skills to become the architects of Myanmar's digital future.",
    // skills: [
    //   "ReactJS",
    //   "Redux",
    //   "NodeJs",
    //   "Material UI",
    //   "HTML",
    //   "CSS",
    //   "JavaScript",
    // ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIdZRgtlY4ZeiYUm1CEaXVcer9cNmqqVr_lNueP_lKfg&s",
    role: "Microsoft Power Apps Developer",
    company: "D3-SG Pte Ltd.",
    date: "July 2023 - Present",
    desc: "My journey working with Microsoft products has been driven by a relentless pursuit of learning and adaptation to new technologies. Fulfilling client needs often requires thinking outside the box, analyzing requirements from diverse perspectives, and brainstorming with my team to cultivate a culture of innovation, resulting in solutions that surpass expectations. Additionally, under the guidance of my team lead, I've had the opportunity to contribute to governmental projects. These projects have presented unique challenges that demand a superb level of critical thinking. This experience has been invaluable, providing me with a deep understanding of government workflows and the pivotal role of technology in their success.",
    // skills: [
    //   "Docker",
    //   "Terraform",
    //   "AWS",
    //   "EC2",
    //   "Portainer",
    //   "Nginx",
    //   "JavaScript",
    //   "TypeScript",
    //   "Node Js",
    //   " Next Js",
    // ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIdZRgtlY4ZeiYUm1CEaXVcer9cNmqqVr_lNueP_lKfg&s",
    role: "Data Management Operator",
    company: "D3-SG Pte Ltd.",
    date: "Dec 2022 - June 2023",
    desc: "At Cyclone IDP Platform, I took my first steps as a data management operator, where I was responsible for transforming vast volumes of invoice documents into structured data. By using advanced AI technologies such as machine learning and computer vision (including OCR/ICR), I meticulously extracted relevant invoice information, then carefully reviewed, ensuring its accuracy and maintaining the complete confidentiality and privacy of sensitive data. I also consistently demonstrated my commitment to client satisfaction by going the extra mile and working late hours when necessary.",
    skills: [
      "Machine Learning",
      "Computer Vision",
      "Regular Expression",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZ__vVmK5ylGUU091ANmJzdKZK13x1rSSppkSk7s_U2Q&s",
    role: "Instructor (Part-time)",
    company: "Thate Pan Institute",
    date: "Dec 2022 - Present",
    desc: "Thate Pan Institute, a leader in affordable, high-quality STEAM education for Burmese youth, is where I cultivate a love for computer science. As a dedicated instructor, I teach a range of computer science courses like Web Development and Python. Beyond the curriculum, I design interactive quizzes and practical exercises to assess understanding and foster critical thinking. When classroom time allows, I foster a space for open dialogue, sharing my knowledge and providing insightful advice for their future studies. This empowers them to build a strong foundation for success, not just in university but throughout their lifelong learning journeys. ",
    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Python",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPH62f_oJkxkbGGxo9IkaLyxGdphUoTVl-B9tHHb5kNA&shttps://media.licdn.com/dms/image/D560BAQEMb3v1ir28OQ/company-logo_200_200/0/1684814294310?e=2147483647&v=beta&t=SswIxGMLy2HxfNdS00fQ-nWjw7o03LHrUSXHvHZ5Rkk",
    role: "Student Affair Officer (Volunteer)",
    company: "The Forward Society",
    date: "May 2022 - Nov 2022",
    desc: "As a student affairs officer in a youth-led organization, I'm passionate about fostering a supportive learning environment. I take ownership of student concerns by handling their affairs and managing student records. This allows me to leverage data analysis to identify valuable insights, such as demographic trends and preferences, guiding event planning and decision-making processes. Furthermore, my strong communication skills bridge the gap between instructors and students, facilitating clear and efficient information exchange. By attending student events and acting as a liaison, I contribute to a positive and collaborative atmosphere where everyone feels valued and supported.",
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQK9RwlQdT6OiebLBwaiPltjZB4_GgknQnt44PBK8HpFQ&s",
    role: "Computer Science and Artificial Intelligence Teacher",
    company: "Thate Pan Hub",
    date: "May 2022 - Present",
    desc: "It has always been my aspiration to educate Burmese children about the significance and potential of computer science as ​I am the one who was raised in an environment where computer science was never regarded as the top choice for a career. When I made the decision to pursue computer science as my undergraduate major, I faced criticism from those around me who doubted its value, failing to see the exciting world waiting to be unlocked behind the ones and zeros. Taking this into consideration, I have been teaching as a teacher at Thate Pan Hub Community which provides free computer science and artificial intelligence education for Burmese children. Sharing the wonders of computer science with over 100 children since 2022 has been incredibly rewarding, and witnessing their parents gain a deeper understanding of its transformative potential has been truly inspiring.",
    // skills: [
    //   "Leadership",
    //   "Mobile Application Development",
    //   "Kotlin",
    //   "XML",
    //   "Figma",
    // ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_w5iXA4lHnfqQ3iyqTXEkUqrCm_t3gW3wnPhzKqjfKw&s",
    school: "Strategy First University Extension (SFUx)",
    date: "Sep 2020 - Sep 2022",
    grade: " * ",
    desc: "The world hit pause during the pandemic, but not my learning. I took advantage of the time to bridge a knowledge gap during this period. With a thirst for learning, I enrolled in DipBME to gain a deeper understanding of business concepts in the IT field. As someone working in IT, I saw a clear limitation. While I could build amazing technical solutions, I often lacked the bigger picture – the business side. Understanding marketing, finance, entrepreneurship and how the IT world interacts with the market felt crucial.  By acquiring these skills through DipBME, I wasn't just adding another line to my resume; I was empowering myself to become a more valuable asset.  Now, I can not only build solutions but understand their market fit, communicate their value, and contribute to their success. It's like having a superpower in the IT industry – the power to transform innovation into profitable solutions. ",
    degree: "Diploma in Business Management and Entrepreneurship (DipBME)",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0ZN9X7vL9eBiUXmk8cXbVB06qET8iKreG0XVAbroDaQ&s",
    school: "University of Computer Studies, Meiktila",
    date: "Dec 2015 - May 2022",
    grade: " ( 4.63 / 5 )",
    desc: "For me, University wasn't just about lectures and exams; it has been a continuous journey of self-improvement. Every year, I pushed myself to be better, striving to be the most impactful version of myself compared to the year before. This growth wasn't just for me – it was for my university too. I wasn't just a student – I was an ambassador, proudly representing my university both as an individual and a team leader, achieving successes that brought pride to our university. Sharing my programming knowledge with younger students also became a rewarding experience. Throughout my university years, learning wasn't just for grades, but also to inspire and empower others on their own journeys. ",
    degree: "B.C.Sc.",
  },
  {
    id: 2,
    img: "https://www.berakahpeneil.com/img/Ministry-of-Education.png",
    school: "No.1 Basic Education High School, Meiktila",
    date: "Jun 2009 - Mar 2015",
    grade: " Distinctions in Chemistry and Biology",
    desc: "Reflecting on my high school years, one standout memory fuels my determination: becoming the first-ever rank-1 student in 7th Grade without the traditional route of constant tutoring. It wasn't easy; at that time, when tutoring was the norm, I broke those stereotypes by pushing my limits day by day and proving that with determination, hard work, and independent learning, anything is possible.",
    degree: "",
  },
];

export const projects = [
  {
    id: 11,
    title: "ASEAN Data Science Explorers Program",
    date: "March 2024 - May 2024",
    description:
      "As a low-code/no-code developer, I am passionate about introducing these transformative technologies to Burmese youth, as they are not yet widely known in my country. Recognizing the limited awareness of these tools in my country, I actively sought opportunities to bridge this gap and participated as a Master Trainer in the ASEAN Data Science Explorers 2024 (ASEANDSE) program, a flagship initiative under the ASEAN Foundation’s partnership with SAP aimed at equipping today’s youth for tomorrow’s challenges. Through this program, I trained young individuals aged 15 to 30 in SAP Analytics Cloud and SAP Build Apps (no-code/low-code platforms), empowering them with practical skills to navigate the evolving technology landscape. By sharing my expertise, I not only advanced their knowledge of data science and low-code technologies but also made a tangible impact on the Burmese youth community, inspiring them to embrace innovation and create opportunities for their future.",
    image:"https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/6.png",
    tags: [
      "ASEANDSE",
      "SAP Cloud Analytics",
      "SAP Build Apps"
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/DecisionHub",
    webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 9,
    title: "Hour Of Code 2022",
    date: "December 2022",
    description:
      "As an instructor, I had the privilege of participating in the Hour of Code 2022 event, which aimed to inspire children aged 10 to 17 from all parts of the country to explore the fundamentals of Computer Science. Understanding the vital role that Computer Science plays in today’s technology-driven world, I dedicated my time to equipping children with essential coding skills and fostering their interest in technology. By volunteering for this program, I was able to make a meaningful impact, empowering the next generation with knowledge and enthusiasm for coding in a way that was both educational and enjoyable.",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/5.png",
    tags: [
      "National Event",
      "Computer Science",
      "Code.org",
      "Thate Pan Hub"
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://trackify-management.netlify.app/",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/7.jpg",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  {
    id: 1,
    title: "MCPA Quiz 2019 (National Level)",
    date: "Sep 2019",
    description:
      "While we didn't achieve the ultimate goal at the national competition, the experience gained was invaluable and irreplaceable. One memorable aspect was representing my region at the national level was an incredible honor. The highlight? Appearing for the first time on a well-known national TV channel 🤩",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/4.jpg",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "Jan 2023 - Mar 2023",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Rishav Chanda",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 3,
    title: "Microsoft Certified: Power BI Data Analyst Associate",
    date: "Sep 27, 2024",
    description:
      "I successfully earned the Microsoft Power BI Analyst certification, demonstrating my expertise in designing and implementing data-driven solutions using Power BI. This certification validates my ability to connect to data sources, transform and model data, create visually compelling reports and dashboards, and share insights across organizations. With a near-perfect score of 946 out of 1000, I showcased my proficiency in advanced data analysis, DAX (Data Analysis Expressions), and leveraging Power BI's capabilities to drive business decisions. This certification reflects my commitment to mastering data visualization and analytics tools to deliver actionable insights.",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/Certificate_04_DataAnalyst.png",
    tags: ["PowerBI", "BusinessIntelligence", "DataAnalysis", "PL300"],
    category: "android app",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Microsoft Certified: Azure Data Fundamentals",
    date: "Sep 27, 2024",
    description:
      "I earned the Microsoft Azure Data Fundamentals certification, showcasing my foundational knowledge of core data concepts and my ability to work with data services in Microsoft Azure. This certification demonstrates my understanding of relational and non-relational data, data storage solutions, and data processing technologies in the cloud. With an exceptional score of 970 out of 1000, I proved my expertise in Azure data services, including Azure SQL Database, Cosmos DB, Synapse Analytics, and data ingestion pipelines. This certification highlights my commitment to leveraging cloud-based data solutions to drive innovation and efficiency in data management and analytics.",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/Certificate_02_DataFundmentals.png",
    tags: ["AzureDataFundamentals", "CloudComputing", "DataManagement"],
    category: "android app",
    github: "https://github.com/rishavchanda/Job-finder-App",
    webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  {
    id: 4,
    title: "MCPA Quiz 2019 (Regional Level)",
    date: "Jul 2019",
    description:
      "In 2018, I participated in the MCPA Quiz for the first time with my friends, which assesses IT knowledge and skills across various domains such as practical programming, algorithms, networking, databases, and information security. Unfortunately, we didn't qualify, not even at the university level. Determined to improve, I diligently filled the knowledge gaps in every sector and practiced rigorously. When the opportunity came for the second attempt, I seized it. This time, our team emerged victorious, claiming the first prize among 13 teams at our university level and also brought the chance to represent my university at the regional level. At the regional level, all the university winners from the Mandalay area competed for a spot to represent the region at nationals. We put in a lot of effort studying and working together as a team. Thanks to this hard work and teamwork, we got the highest score! This win booked our ticket to national level, where we got to proudly represent our region. ",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/3.jpg",
    tags: ["MCPA Quiz Myanmar"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Universities English Speaking Contest 2019",
    date: "Aug 8, 2019",
    description:
      "Public speaking has always fascinated me—it’s not just about words but about persuasion, confidence, and storytelling. I first put my skills to the test in my university’s English Speaking Contest, where I delivered a speech that earned me first place. That victory led me to an even greater challenge: representing my university in the Universities English Speaking Contest (UESC). Preparing for the UESC was an intense but rewarding experience. I refined my speech, practiced under pressure, and focused on engaging the audience with authenticity and impact. Standing on stage, competing against talented speakers from other universities, I realized the power of clear, confident communication. This journey sharpened my public speaking and critical thinking skills, proving that every great speech starts with a story worth telling.",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/2.jpg",
    tags: ["UESC", "EnglishContest", "Public Speaking", "Debate"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 6,
    title: "Huawei Open Youth Program 2019",
    date: "May 2019",
    description:
      "My hard work paid off in my fourth year when I achieved the #1 ranking, securing an opportunity to participate in the Huawei Open Youth Program. This program offered a behind-the-scenes look at Huawei's local and global operations, and their cutting-edge advancements in 5G and AI. Beyond the impressive technology, the program shed light on the transformative impact of AI in everyday lives, particularly how it can empower people with disabilities. This experience sparked a passion within me for the potential of technology to create a more inclusive world.",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/1.jpg",
    tags: ["Huawei","AI"],
    category: "web app",
    github: "https://github.com/rishavchanda/Breaking-Bad",
    webapp: "https://breaking-bad-webapp.netlify.app",
  },
  {
    id: 7,
    title: "Microsoft Certified: Azure AI Fundamentals",
    date: "June 24, 2024",
    description:
      "My journey into AI started with curiosity—how does AI make decisions, recognize patterns, and drive automation? To solidify my understanding, I pursued the Microsoft Azure AI Fundamentals certification, diving deep into machine learning, computer vision, natural language processing (NLP), and responsible AI. Through this journey, I gained hands-on experience in leveraging Azure's AI tools to innovate and automate processes, making technology more accessible and impactful. With a strong foundation in AI principles and ethical AI considerations, I am now eager to apply these skills to real-world projects, integrating AI solutions into Microsoft Power Platform and beyond. This achievement not only validates my technical skills but also fuels my passion for exploring how AI can shape the future of industries and improve lives. I’m excited for what’s next! 🚀",
    image:
      "https://raw.githubusercontent.com/PaulinHein1999/Memory/main/assets/Certificate_01_AIFundmentals.png",
    tags: ["CognitiveServices", "MachineLearning", "Azure AI Services", "AI Ethics"],
    category: "android app",
    github: "https://github.com/rishavchanda/Quiz-Earn",
    webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

